/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TerminalDiagnosisRequestDto
 */
export interface TerminalDiagnosisRequestDto {
    /**
     * 
     * @type {string}
     * @memberof TerminalDiagnosisRequestDto
     */
    pspTerminalId: string;
}

/**
 * Check if a given object implements the TerminalDiagnosisRequestDto interface.
 */
export function instanceOfTerminalDiagnosisRequestDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "pspTerminalId" in value;

    return isInstance;
}

export function TerminalDiagnosisRequestDtoFromJSON(json: any): TerminalDiagnosisRequestDto {
    return TerminalDiagnosisRequestDtoFromJSONTyped(json, false);
}

export function TerminalDiagnosisRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TerminalDiagnosisRequestDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pspTerminalId': json['pspTerminalId'],
    };
}

export function TerminalDiagnosisRequestDtoToJSON(value?: TerminalDiagnosisRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pspTerminalId': value.pspTerminalId,
    };
}

